import { createContext, ReactNode } from 'react'
import { ChecklistType } from '../../enums'

export interface FormSchemaAssetData {
  name?: string
  type?: string
  assetId?: number
}

export interface FormSchemaAppData {
  asset?: FormSchemaAssetData
  clientId?: number
  checklistId?: number
  checklistType?: ChecklistType
  assetStartupRoutineId?: number
}

export const FormSchemaAppDataContext = createContext<FormSchemaAppData>({})

interface Props {
  value?: FormSchemaAppData
  children: ReactNode
}

export const FormSchemaAppDataContextProvider = ({ value, children }: Props) => (
  <FormSchemaAppDataContext.Provider value={value ?? {}}>{children}</FormSchemaAppDataContext.Provider>
)
